import { Injectable, OnDestroy } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { TranslationHelperService } from '../services/translations/translation-helper.service';
import { take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { unsubscribe } from '../utils/helpers';

@Injectable()
export class AuthenticatedGuard implements CanActivate, OnDestroy {
  subscriptions: Subscription[] = [];

  constructor(
    protected authenticationService: AuthenticationService,
    private translationHelper: TranslationHelperService,
    private router: Router,
  ) {
    unsubscribe(this.subscriptions);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    let isAuthenticated = this.authenticationService.isAuthenticated();

    if (!isAuthenticated) {
      this.subscriptions.push(
        this.translationHelper.getLanguage().pipe(take(1)).subscribe(
          (language) => {
            this.router.navigate([language + '/login'], {
              queryParams: {
                redirect: state.url
              }
            });
          },
          (err) => console.error(this.constructor.name, 'getLanguage', err),
        ))
    }

    return isAuthenticated;
  }
  ngOnDestroy(): void {
    unsubscribe(this.subscriptions);
  }
}
